var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", [
    _c("span", { staticClass: "item", on: { click: _vm.remove } }, [
      _c("em", [_vm._v("#")]),
      _vm._v(" " + _vm._s(_vm.text) + " "),
      _c("i", { staticClass: "icon icon-close" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }